<template>
  <main>
    <div class="flex items-center justify-center w-full" @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @drop.prevent="onDrop">
      <label :class="{ disabled: isUploading }" for="dropzone-file" ref="dropzone"
             class="flex flex-col items-center justify-center w-full h-48 cursor-pointer rounded bg-slate-50 dark:bg-neutral-700 border border-dashed border-slate-300 text-center px-5 py-8">
        <div class="flex flex-col items-center justify-center pt-5 pb-6">
          <svg xmlns="http://www.w3.org/2000/svg" class="size-10 mb-3 text-gray-400 dark:text-white" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/>
          </svg>
          <p class="mb-2 text-sm text-gray-500 dark:text-white">Bild(er) / Datei(en) hier reinziehen oder <span
            class="font-semibold">klicken zum hochladen</span></p>
          <p class="text-xs text-gray-500 dark:text-white">PNG, JPG, PDF (max. 30 MB)</p>
        </div>
        <input id="dropzone-file" type="file" class="sr-only" multiple @change="onSelectFiles"/>
      </label>
    </div>
    <div class="files-list mt-6">
      <FileItem v-for="file in selectedFiles" :key="file.file.name" :file="file"/>
    </div>
    <div class="grid grid-cols-3 lg:grid-cols-5 md:grid-cols-4 gap-4" v-if="images.length">
      <div class="rounded" v-for="(image, key) in images">
        <div class="flex flex-col items-stretch">
          <div class="relative rounded-md group">
            <img
              :src="image"
              class="w-full aspect-square object-cover rounded-lg"/>
            <button @click.prevent="remove(key, 'image')"
                    class="invisible group-hover:visible absolute top-0 right-0 p-2 text-red-700 bg-white/80 hover:bg-white/80 hover:text-red-700">
              <svg xmlns="http://www.w3.org/2000/svg" class="size-6" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                      d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1M6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex gap-4" v-if="files.length">
      <div v-for="(file, key) in files">
        <div class="p-8 bg-gray-50 rounded relative group">
          <p class="uk-text-emphasis mb-0">
            <svg xmlns="http://www.w3.org/2000/svg" class="size-8" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M10 3v4a1 1 0 0 1-1 1H5m4 6l2 2l4-4m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1"/>
            </svg>
            {{ file.originFilename }}
          </p>
          <button @click.prevent="remove(key, 'file')"
                  class="invisible group-hover:visible absolute top-0 right-0 p-1 text-red-700 bg-white/80 hover:bg-white/80 hover:text-red-700">
            <svg xmlns="http://www.w3.org/2000/svg" class="size-5" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1M6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import {uploadFile} from '../../../services/upload.service'
import FileItem from "./FileItem.vue";
import axios from "axios";

export default {

  props: {
    url: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    }
  },

  computed: {
    isUploading() {
      this.selectedFiles.some((file) => file.status === "uploading")
    }
  },
  components: {FileItem},

  data() {
    return {
      selectedFiles: [],
      images: [],
      files: [],
      uploaded: [],
    }
  },

  methods: {
    onSelectFiles(event) {
      const target = event.target;
      if (target.files === null) {
        return;
      }
      this.buildFileList(target.files)
      this.uploadSelectedFiles()
    },
    onDrop(e) {
      this.$refs.dropzone.classList.remove('border-gray-800', 'shadow-lg')
      this.$refs.dropzone.classList.add('border-slate-300')
      this.buildFileList(e.dataTransfer.files)
      this.uploadSelectedFiles()
    },
    onDragOver() {
      this.$refs.dropzone.classList.add('border-gray-800', 'shadow-lg')
      this.$refs.dropzone.classList.remove('border-slate-300')
    },
    onDragLeave() {
      this.$refs.dropzone.classList.remove('border-gray-800', 'shadow-lg')
      this.$refs.dropzone.classList.add('border-slate-300')
    },
    buildFileList(files) {
      this.selectedFiles = [];

      Array.from(files).forEach((file) => {
        this.selectedFiles.push({
          file: file,
          percentage: 0,
          status: "pending",
        });
      });
    },
    uploadSelectedFiles() {
      this.selectedFiles.forEach((file) => {
        file.status = "uploading";
        file.percentage = 0;

        uploadFile(this.url, file.file, {data: JSON.stringify({...this.data})}, (event) => {
          file.percentage = Math.round((100 * event.loaded) / event.total) - 1;
        })
          .then((response) => {
            file.status = "success";
            file.percentage = 100
            this.$emit('uploaded', response.data)
            this.uploaded.push(response.data)

            if (file.file.type.match('image')) {

              const reader = new FileReader()
              reader.onload = (e) => {
                this.images.push(e.target.result)
              }
              reader.readAsDataURL(file.file)
            } else {
              this.files.push(file.file)
            }

          })
          .catch((error) => {
            if (error.response) {
             //console.log(error.response.data);
             // console.log(error.response.status);
             // console.log(error.response.headers);
            } else if (error.request) { // no response
              //console.log(error.request);
              // instance of XMLHttpRequest in the browser
              // instance of http.ClientRequest in node.js
            } else { // Something wrong in setting up the request
             // console.log('Error', error.message);
            }
            //console.log(error.config);
            file.status = "failed";
          });
      });
    },
    remove(index, type) {
      axios.post('/wp-json/ansolution/v1/forms/image/remove/' + this.uploaded[index].id).then(response => {
        if (type === 'image') {
          this.images.splice(index, 1);
        } else {
          this.files.splice(index, 1);
        }
        this.uploaded.splice(index, 1);
      })
    },
    validateSize() {
      const fileSize = this.totalSize / 1024 / 1024; // in MB
      if (fileSize > 28) {
        return false
      } else {
        return true
      }
    }
  },
}
</script>
